'use strict';

const BaseStore = require('fluxible/addons/BaseStore');

const {STORE} = require('../constants/trendingConstants');
const {filterCollectionUniqueItems} = require('../utils/filterCollectionUniqueItems.es');

class TrendingStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this._collections = {};
    }

    getCollection(collectionKey) {
        return this._collections[collectionKey];
    }

    /**
     * Returns an array of filtered collections containing unique items.
     *
     * @param {array} collectionKeys - an array of Backbone collection keys.
     * @param {number} itemsPerPage - number of unique items to filter out.
     * @returns {array}
     */
    getCollectionsFiltered(collectionKeys, itemsPerPage) {
        const collections = collectionKeys.map(key => {
            return this.getCollection(key).toJSON();
        });
        const flatCollections = Array.prototype.concat.apply([], collections);

        return filterCollectionUniqueItems(flatCollections, itemsPerPage);
    }

    getTrend(collectionKey, rank = 1) {
        const collection = this._collections[collectionKey];

        if (collection) {
            return collection.findWhere({rank}) || collection.first();
        }

        return undefined;
    }

   /**
     * Returns trends title and url
     */
    getTrends(collectionKey) {
        const collection = this._collections[collectionKey];

        if (collection) {
            return collection.map(trend => {
                return {
                    modelId: trend.cid,
                    title: trend.get('displayName'),
                    url: trend.get('url')
                };
            });
        }

        return [];
    }

    getItems(collectionKey, rank = 1) {
        const trend = this.getTrend(collectionKey, rank);
        return trend.get('items');
    }

    getUrl(collectionKey, rank = 1) {
        const trend = this.getTrend(collectionKey, rank);
        return trend.get('url');
    }

    getTitle(collectionKey, rank) {
        const trend = this.getTrend(collectionKey, rank);
        const {name} = trend.get('trendingElement');

        return name;
    }

    _handleFetchSuccess(payload) {
        const {collectionKey, collection} = payload;

        this._collections[collectionKey] = collection;
        this.emitChange();
    }
}

TrendingStore.storeName = 'TrendingStore';

TrendingStore.handlers = {
    [STORE.FETCH_SUCCESS]: '_handleFetchSuccess'
};

module.exports = TrendingStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/TrendingStore.es.js